import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';

import { getUserInfo } from './thunks';

export type UserState = {
  balance: string;

  cratBalance: string;
  usdtBalance: string;
  usdcBalance: string;

  totalSpend: string;
  tier: string;
  bonusTokensReceived: string;
  referralReceived: string;
  referralFather: string;
};

const initialUserState: UserState = {
  balance: '0',

  cratBalance: '0',
  usdtBalance: '0',
  usdcBalance: '0',

  totalSpend: '0',
  tier: '0',
  bonusTokensReceived: '0',
  referralReceived: '0',
  referralFather: '',
};

const userSlice = createSlice({
  name: 'user',
  initialState: initialUserState,
  reducers: {
    updateUserState: (state: UserState, action: PayloadAction<Partial<UserState>>) => ({
      ...state,
      ...action.payload,
    }),

    clearUserState: () => ({
      ...initialUserState,
    }),

    disconnectWalletState: () => {
      localStorage.removeItem('walletconnect');
      Cookies.remove('token');
      return {
        ...initialUserState,
      };
    },
  },

  extraReducers(builder) {
    builder.addCase(getUserInfo.fulfilled, (state, { payload }) => {
      if (!payload) return state;
      const { userInfo, ...balances } = payload;
      return {
        ...state,
        ...userInfo,
        ...balances,
      };
    });
  },
});

export const { reducer } = userSlice;
export const { actions } = userSlice;
